import { PatientInformation } from "@core/models/patient-registration/patient-information";

 
export class storePatientIdVisitIdAction {
    static readonly type = '[patientIdvisitId] PatientIdvisitId';

    constructor(public payload: {patientId:number,visitId:any,gender:string,patientModel:PatientInformation}) {
    }
    // ,visitTime:string
}
export class clearPatientIdVisitIdAction {
    static readonly type = '[clearpatientIdvisitId] ClearPatientIdvisitId';

    constructor(public payload: {}) {
    }
    // ,visitTime:string
}
// export class storePatientBedDetailsAction {
//     static readonly type = '[patientIdvisitId] StorePatientBedDetails';

//     constructor(public payload: { bedName: string, bedId:number, nursingStation:string, roomId:number, nursingStationId:number, roomName:string, floorId:number, departmentId:number }) {
//     }
// }
